import { createApp } from "vue";
import App from "./App.vue";
import Router from "./config/Router";
import "bootstrap/dist/css/bootstrap.css";
import "font-awesome/css/font-awesome.css";
import AxiosAdapter from "./infra/AxiosAdapter";
import AuthService from "./service/AuthService";
import i18n from './config/i18n'
import mitt from "mitt";

const baseUrl = process.env.VUE_APP_BASE_URL;

const execute = async function () {
	const authService = new AuthService(new AxiosAdapter(), baseUrl);
	const session = await authService.getSession();
	const app = createApp(App, { authService });
	app.config.globalProperties.$session = session;
	app.config.globalProperties.$emitter = mitt();
	app.use(new Router(baseUrl).build());
	app.use(i18n);
	app.mount('#app');
}

execute();
